import React from 'react';
import tasnuvaCourierLogo from '../../assets/images/tasnuva_courier.png';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();
    return (
        <div className='flex flex-col w-full h-[85vh] md:h-[93vh] justify-center items-center bg-[#f0f0f0]'>
            <div className='flex flex-col gap-2 items-center justify-center'>
                <div className='w-[300px] h-16'>
                    <img src={tasnuvaCourierLogo} alt="Tasnuva Courier" className='h-full w-full' />
                </div>
                <div className='h-[60vh]'>
                    <img className='h-full' src='https://res.cloudinary.com/di23omfvx/image/upload/v1692414392/404_xugicp.gif' alt="404 Not Found" />
                </div>
            </div>
            <div className='flex items-center'>
                <div onClick={() => navigate('/')} className={`text-text_1 text-lg bg-primary px-5 py-1 rounded-md shadow font-bold cursor-pointer hover:animate-bounce transition-all`}>Back To Home</div>
            </div>
        </div>
    );
};

export default NotFound;
